import type { InputDataT } from '../../labelling/types/studio-interface.type';

/**
 * Returns the initial value for frameCountAtom based on media type.
 *
 * - Modern video (videoUrl present): 0 — real count determined after media loads via SET_FRAME_COUNT.
 * - PDF: inputData.frames.length — all pages are known upfront.
 * - Image or legacy video (image sequence): 1 — single frame or handled via SET_FRAME_COUNT.
 */
export function getInitialFrameCount(inputData: InputDataT): number {
  if ('videoUrl' in inputData) {
    return inputData.frames.length;
  }
  if ('pdfUrl' in inputData) {
    return inputData.frames.length;
  }
  return 1;
}